import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ChatSession {
  id: string;
  user_id: string;
  title: string;
  created_at: string;
  updated_at: string;
  message_count?: number;
}

export interface ChatMessage {
  id: string;
  session_id: string;
  role: 'user' | 'assistant';
  content: string;
  sql_query?: string;
  db_used?: string;
  row_count?: number;
  columns?: string[];
  rows?: (string | null)[][];
  is_error?: string;
  created_at: string;
}

export interface SessionDetail extends ChatSession {
  messages: ChatMessage[];
}

export interface ChatResponse {
  session_id: string;
  answer: string;
  sql: string;
  db: string;
  explanation: string;
  columns: string[];
  rows: (string | null)[][];
  row_count: number;
  error: string | null;
  user_message_id: string;
  assistant_message_id: string;
}

@Injectable({ providedIn: 'root' })
export class AgentService {
  private http = inject(HttpClient);
  private base = `${environment.agentUrl ?? environment.baseUrl}/agent`;

  createSession(title?: string): Observable<ChatSession> {
    return this.http.post<ChatSession>(`${this.base}/sessions`, { title });
  }

  getSessions(): Observable<ChatSession[]> {
    return this.http.get<ChatSession[]>(`${this.base}/sessions`);
  }

  getSession(id: string): Observable<SessionDetail> {
    return this.http.get<SessionDetail>(`${this.base}/sessions/${id}`);
  }

  deleteSession(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/sessions/${id}`);
  }

  chat(sessionId: string, question: string): Observable<ChatResponse> {
    return this.http.post<ChatResponse>(`${this.base}/sessions/${sessionId}/chat`, { question });
  }
}
